export default {
  menu: 'Conversion',
  title: 'Conversion',

  general: {
    table: {
      header: {
        row: 'Row',
        date: 'Date',
        description: 'Description',
        invoiceId: 'Invoice No.',
        status: 'Status',
        creator: 'Creator',
        sourceBarcode: 'Source barcode',
        sourceName: 'Source name',
        sourceCount: 'Source QTY',
        destinationBarcode: 'Destination barcode',
        destinationName: 'Destination name',
        destinationCount: 'Destination QTY',
        rate: 'Exchange rate',
        warehouse: 'Warehouse',
        count: 'Qty',
        delete: 'Delete',
        restore: 'Restore'
      }
    },

    labels: {
      allProduct: 'All products',
      warehouse: 'Warehouse',
      id: 'ID',
      registryDate: 'Registry date',
      type: 'Type',
      status: 'Status'
    },

    notifications: {
      isExists: {
        message: 'This value is in the list',
        dynamicMessage: 'There are {name} in the list'
      },

      increaseCount: {
        message: 'Number of items added',
        dynamicMessage: 'Number of { names } added'
      },

      productNotFount: 'No product found with this barcode',
      quantity: 'Inventory is not enough!',
      dynamicQuantity: 'There is not enough stock of {name}!',

      insert: {
        success: 'Warehouse conversion registered successfully',
        error: 'Warehouse conversion registration was incorrect!'
      },

      edit: {
        success: 'Warehouse conversion edited successfully',
        error: 'Warehouse conversion editing encountered an error!'
      },

      delete: {
        success: 'Warehouse conversion successfully deleted',
        error: 'Deleting the warehouse conversion was accompanied by an error'
      },

      restore: {
        success: 'Warehouse conversion successfully restored',
        error: 'Restore warehouse conversion was accompanied by an error'
      },

      parseError: {
        storeroom: 'Warehouse not selected!',
        stocks: 'No items selected!',
        description: 'Description field is empty!',
        invoiceNumber: 'This invoice number is already selected!',
        quantity: 'The number of selected products is not valid!',
        noProductEnter: 'No Product Selected!'
      }
    },

    confirmations: {
      delete: {
        title: 'Confirmation of deletion of warehouse conversion',
        body: 'If the warehouse conversion is deleted, all the documents and delivery note of the warehouse related to the invoice will be deleted. Are you sure? '
      },
      forceDelete: {
        title: 'Confirmation of deletion of invoice',
        body: 'If the invoice is deleted, the information of invoice deleted and cant restore it. Are you sure? '
      },
      forceUpdate: {
        title: 'Warehouse conversion edit confirmation',
        body: 'By edit warehouse conversion, All documents related to this invoice change. Are you sure of confirming edit warehouse conversion?'
      }
    },

    types: {
      deficit: 'Deficit',
      surplus: 'Surplus'
    },

    statusTypes: {
      draft: 'Draft',
      confirmed: 'Approved',
      deleted: 'Deleted'
    }
  },

  list: {
    title: 'Conversion'
  },

  trash: {
    title: 'Removed Warehouse Conversion List'
  },

  insert: {
    title: 'Insert Warehouse Conversion'
  },

  profile: {
    title: 'Warehouse Conversion Profile'
  },

  edit: {
    title: 'Edit Warehouse Conversion'
  },

  logs: {
    title: 'Warehouse Conversion Logs'
  }
}
